import { useEffect } from "react";
import { Box, Grid } from "@mui/material";
import { H4, H5 } from "components/Typography";
import { FC } from "react";
import { API_BASE_URL } from "Api/EndPoints";
import { toast } from "react-hot-toast";
import moment from "moment";

// root component interface
interface CardProps {
  data: any;
  onPressMore?: any;
  onPressPause?: any;
  onPressCancel?: any;
  onpressYesPauseSIP: (value: any) => void;
  onpressYesCancelSIP: (value: any) => void;
  onPressCross?: any;
  moreValue?: any;
  pausesipvalue?: any;
  cancelsipvalue?: any;
  defaultValue?: any;
  index?: number;
}

const SIPCard: FC<CardProps> = ({
  data,
  onPressMore,
  onPressPause,
  onPressCancel,
  onPressCross,
  onpressYesPauseSIP,
  onpressYesCancelSIP,
  moreValue,
  pausesipvalue,
  cancelsipvalue,
  defaultValue,
  index,
}) => {
  useEffect(() => {}, []);

  const onEmptyPausePress = () => {
    toast.error("Your SIP is already paused. No further action is required");
  };

  const getImgUrl = (pic: string) => {
    pic = pic.toString().slice(1);
    if (pic) {
      return API_BASE_URL + pic;
    }
    return "";
  };

  return (
    <>
      {pausesipvalue ? (
        <Grid xs={15} md={5} sx={sxStyleBox}>
          <Grid
            alignSelf="flex-end"
            justifyContent="flex-end"
            alignItems="flex-end"
            display="flex"
            onClick={onPressCross}
          >
            <Box
              component="img"
              src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/crossIcon.svg"
              sx={sxStyleImageCross}
            />
          </Grid>
          <H4 textAlign="center" sx={{ mt: { xs: 3, md: 0, sm: 0 } }}>
            Are you sure you want to pause your SIP for three months?
          </H4>

          <Grid
            justifyContent="center"
            alignItems="center"
            sx={{
              display: "flex",
              mt: { xs: 3, md: 0, sm: 0 },
              md: { xs: 6, md: 0, sm: 0 },
            }}
          >
            {/* onhandleInvest */}
            <Grid
              onClick={() => onpressYesPauseSIP(data)}
              textAlign="center"
              sx={{
                borderBottomLeftRadius: 8,
                p: 2,
                background: "#016AD6",
                color: "#fff",
                width: "50%",
                borderRight: "1px solid #000000",
              }}
            >
              Yes
            </Grid>
            <Grid
              onClick={onPressCross}
              textAlign="center"
              sx={{
                borderBottomRightRadius: 8,
                p: 2,
                background: "#016AD6",
                color: "#fff",
                width: "50%",
              }}
            >
              No
            </Grid>
          </Grid>
        </Grid>
      ) : null}
      {cancelsipvalue ? (
        <Grid xs={15} md={5} sx={sxStyleBox}>
          <Grid
            alignSelf="flex-end"
            justifyContent="flex-end"
            alignItems="flex-end"
            display="flex"
            onClick={onPressCross}
          >
            <Box
              component="img"
              src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/crossIcon.svg"
              sx={sxStyleImageCross}
            />
          </Grid>
          <H4 textAlign="center" sx={{ mt: { xs: 3, md: 0, sm: 0 } }}>
            Are you sure you want to cancel this SIP?
          </H4>

          <Grid
            justifyContent="center"
            alignItems="center"
            sx={{
              display: "flex",
              mt: { xs: 3, md: 0, sm: 0 },
              md: { xs: 6, md: 0, sm: 0 },
            }}
          >
            <Grid
              onClick={() => onpressYesCancelSIP(data)}
              textAlign="center"
              sx={{
                borderBottomLeftRadius: 8,
                p: 2,
                background: "#016AD6",
                color: "#fff",
                width: "50%",
                borderRight: "1px solid #000000",
              }}
            >
              Yes
            </Grid>
            <Grid
              onClick={onPressCross}
              textAlign="center"
              sx={{
                borderBottomRightRadius: 8,
                p: 2,
                background: "#016AD6",
                color: "#fff",
                width: "50%",
              }}
            >
              No
            </Grid>
          </Grid>
        </Grid>
      ) : null}

      {defaultValue ? (
        <Grid xs={15} md={5} sx={sxStyleBox}>
          <Box
            sx={{
              display: "flex",
              p: { xs: 1, sm: 1, md: 2 },
            }}
          >
            <Box
              component="img"
              src={getImgUrl(data?.logo)}
              sx={sxStyleImage}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                marginLeft: 1.5,
              }}
            >
              <H4 color="#000000" sx={text}>
                {data?.schemeName ?? "Unknown Scheme"}
              </H4>

              <H4 fontSize={14} color={"#868686"}>
                {`Installment date: ${moment(data?.nextInstallmentDate).format(
                  "DD MMM"
                )}`}
              </H4>
              <H4 fontSize={14} color={"#868686"} fontWeight={"600"}>
                {`SIP Amount: ₹${data?.amount}`}
              </H4>
            </Box>
          </Box>

          {moreValue ? (
            <Grid
              justifyContent="center"
              alignItems="center"
              sx={{
                display: "flex",
                mt: 0,
              }}
            >
              <Grid
                onClick={
                  data?.sipPauseRes?.pauseId ? onEmptyPausePress : onPressPause
                }
                textAlign="center"
                sx={{
                  borderBottomLeftRadius: 8,
                  p: 2,
                  background: data?.sipPauseRes?.pauseId ? "#bbb" : "#016AD6",
                  color: "#fff",
                  width: "50%",
                  borderRight: "1px solid #000000",
                }}
              >
                Pause
              </Grid>

              <Grid
                onClick={onPressCancel}
                textAlign="center"
                sx={{
                  borderBottomRightRadius: 8,
                  p: 2,
                  background: "#016AD6",
                  color: "#fff",
                  width: "50%",
                }}
              >
                Cancel
              </Grid>
            </Grid>
          ) : (
            <Grid
              justifyContent="center"
              alignItems="center"
              sx={{ p: 2, display: "flex" }}
              onClick={onPressMore}
            >
              <Box
                component="img"
                sx={{
                  height: 10,
                  minwidth: {
                    md: 10,
                    xs: 10,
                    sm: 10,
                  },
                  mr: 1,
                }}
                src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/down-arrow.svg"
                alt="saas-dasboard-footer"
              />
              <H5 color="#016AD6" fontWeight={"500"}>
                More Options
              </H5>
            </Grid>
          )}
        </Grid>
      ) : null}
    </>
  );
};

export default SIPCard;
const sxStyleImage = {
  height: {
    xs: 30,
    sm: 30,
    md: 50,
  },
  minwidth: {
    xs: 30,
    sm: 30,
    md: 30,
  },
  m: 0.6,
  mb: 0,
};

const sxStyleImageCross = {
  p: 0.4,
  border: 1,
  borderColor: "#FF0000",
  borderRadius: 5,
  position: "relative",
  top: -6,
  right: -6,
  height: {
    xs: 15,
    sm: 15,
    md: 15,
  },
  minwidth: {
    xs: 30,
    sm: 30,
    md: 30,
  },
};

const text = {
  fontFamily: "'Poppins', sans-serif",
  display: "flex",
  fontSize: 15,
  mt: 0.13,
  fontWeight: "500",
};

const sxStyleBox = {
  background: "#fff",
  borderRadius: 4,
  justifyContent: "space-between",
  display: "flex",
  flexDirection: "column",
  mt: {
    md: 1,
    xs: 2,
    sm: 1,
  },
  border: "0.5px solid rgba(219, 219, 219, 1)",
  ml: 3,
  // background:'#f00'
};
